export default __webpack_public_path__ + "static/GT-Super-Display-Light-a916ec3718a55afa1b8853f945a3609b.woff2";